module.exports = __webpack_public_path__ + "static/media/antivandalProtector.1a30ca58.jpeg";